import { NgModule } from '@angular/core';
import { registerLocaleData, CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http/';
import localePt from '@angular/common/locales/pt';
import { RouterModule } from '@angular/router';
import { MenuLateralComponent } from 'src/app/Components/menu-lateral/menu-lateral.component';
import { HeaderComponent } from 'src/app/Components/header/header.component';
import { SecureRoutingModule } from './secure.routing';
import { HomeComponent } from './home/home.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { LoggedInGuard } from 'src/app/Helpers/Guards/loggedin.guard';
import { DynamicScriptLoaderService } from 'src/app/Services/dynamic-script-loader.service';
import { SecureComponent } from './secure.component';
import { AdminGuard } from 'src/app/Helpers/Guards/admin.guard';
import { QuestionarioComponent } from './questionario/questionario.component';
import { BlockUIModule } from 'ng-block-ui';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton'
import { CadastroComponent } from './cadastro/cadastro.component';
import { InputMaskModule } from 'primeng/inputmask';
import { EnumeradorService } from 'src/app/Services/enumerador.service';
import { MunicipioService } from 'src/app/Services/municipio.service';
import { SugestaoService } from 'src/app/Services/sugestao.service';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    MenuLateralComponent,
    HeaderComponent,
    HomeComponent,
    SecureComponent,
    QuestionarioComponent,
    CadastroComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    SecureRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BlockUIModule,
    RouterModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    RadioButtonModule,
    InputMaskModule,
  ],
  exports: [
    HttpClientModule,
    FormsModule,
    RouterModule,
    BlockUIModule,
    ReactiveFormsModule,
    MenuLateralComponent,
    HeaderComponent,
    SecureComponent,
  ],
  providers: [
    LoggedInGuard, 
    AdminGuard, 
    DynamicScriptLoaderService,
    EnumeradorService,
    MunicipioService,
    SugestaoService
  ]
})

export class CoreModule { }